// extracted by mini-css-extract-plugin
export default {"show-on-medium-screen":"Pagination_show-on-medium-screen__MfxPI","wrapper":"Pagination_wrapper__Rvhto","navigation":"Pagination_navigation__VVXan"};